import { render, staticRenderFns } from "./vue-core-image-upload.vue?vue&type=template&id=664bc42d&"
import script from "./vue-core-image-upload.vue?vue&type=script&lang=js&"
export * from "./vue-core-image-upload.vue?vue&type=script&lang=js&"
import style0 from "./style/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports